import { parsePhoneNumberFromString } from "libphonenumber-js"
import React from "react"
import { injectIntl } from "react-intl"
import Input, { Country } from "react-phone-number-input/input"
import GlobalHelper from "../GlobalHelper"

type OwnProps = {
    phoneNumber: string
    checkValidForm: boolean
    onChange: (phone, isValidPhoneNumber: boolean) => void
    placeholder: string
    name: string
    id: string
    type: string
    className: string
    message: JSX.Element | undefined | string
    required: boolean
    defaultCountry: Country
}

const PhoneNumberInput = (props: OwnProps) => {
   
    const isInvalidPhone = () => {
        return GlobalHelper.checkPhoneNumberValidity(props.checkValidForm, props.phoneNumber)
    }

    return (
        <>
            <Input
                className={"form-control " + (isInvalidPhone() ? "is-invalid" : (props.checkValidForm ? "is-valid" : ""))}
                id={props.id}
                name={props.name}
                value={parsePhoneNumberFromString(props.phoneNumber,props.defaultCountry)?.number || props.phoneNumber ||  ""}
                //addInternationalOption={false}
                defaultCountry={props.defaultCountry || undefined}
                placeholder={props.placeholder}
                onChange={(phoneNumber) => {
                    const phone = phoneNumber ?? ""
                    props.onChange(phone, GlobalHelper.isValidPhoneNumberInput(phone))
                }}
            />
            <div className={(isInvalidPhone() ? "d-block " : "d-none ") + "invalid-feedback"}>
                {props.message}
            </div>
        </>
    )

}

export default injectIntl(PhoneNumberInput)



// WEBPACK FOOTER //
// ./src/common/inputs/PhoneNumberInputComponent.tsx